const STYLES = {
  not_started: "bg-slate-100 text-slate-700 border-slate-300",
  in_class: "bg-amber-100 text-amber-800 border-amber-300",
  homework_submitted: "bg-teal-100 text-teal-800 border-teal-300",
  complete: "bg-emerald-100 text-emerald-800 border-emerald-300",
  pending: "bg-orange-100 text-orange-800 border-orange-300",
  approved: "bg-emerald-100 text-emerald-800 border-emerald-300",
  declined: "bg-rose-100 text-rose-800 border-rose-300",
  new: "bg-orange-100 text-orange-800 border-orange-300",
  contacted: "bg-sky-100 text-sky-800 border-sky-300",
  enrolled: "bg-emerald-100 text-emerald-800 border-emerald-300",
  archived: "bg-slate-100 text-slate-600 border-slate-300",
  requested: "bg-orange-100 text-orange-800 border-orange-300",
  confirmed: "bg-emerald-100 text-emerald-800 border-emerald-300",
  hidden: "bg-slate-100 text-slate-600 border-slate-300",
  closed: "bg-slate-100 text-slate-600 border-slate-300",
};

const LABELS = {
  not_started: "Not started",
  in_class: "In class",
  homework_submitted: "Homework submitted",
  complete: "Complete",
  pending: "Pending",
  approved: "Approved",
  declined: "Declined",
  new: "New lead",
  contacted: "Contacted",
  enrolled: "Enrolled",
  archived: "Archived",
  requested: "Requested",
  confirmed: "Confirmed",
  hidden: "Hidden",
  closed: "Closed",
};

export function StatusBadge({ status, testId }) {
  const s = status || "not_started";
  return (
    <span className={`inline-flex items-center rounded-full border px-2.5 py-0.5 text-[11px] font-semibold font-mono-ui uppercase tracking-wide ${STYLES[s] || STYLES.not_started}`} data-testid={testId}>
      {LABELS[s] || s}
    </span>
  );
}
